import React from "react";
import {getCountryName} from "../../util/countryCodes";

const CountrySelectionStatus = ({ country, userSubscriptions, setShowModal }) => {

    const looksLikeText = (<>{`Looks like you’re in: `}<b style={{ display: "block" }}>{`${country && getCountryName(country)}`}</b></>)
    const hasNoSubscriptions = !userSubscriptions || userSubscriptions.length === 0;

    return (country && <div className={hasNoSubscriptions ? "location-editable" : "location-non-editable"}>
    {hasNoSubscriptions ?
        <>
        <div className="looks-like-text-dashboard">
            {looksLikeText}
        </div>
        <div>
            <a onClick={() => setShowModal(true)} style={{ fontWeight: 'bold' }}>Change your location</a>
        </div>
        </> :
        <>{country && <>
            <span className="looks-like-text-dashboard">
                {looksLikeText}
            </span>
        </>}
        </>
    }
    </div>)
}

export default CountrySelectionStatus